import { useTranslation } from 'react-i18next'

import EditWidgetForm from './EditWidgetForm'
import Widget from '../Widget'

export const useCOMPLIANCES_COUNTER_CONFIG = () => {
  const { t } = useTranslation('common')

  return {
    id: 'COMPLIANCES_COUNTER',
    name: t('widgets.compliancesCounter.name'),
    description: t('widgets.compliancesCounter.description'),
    color: 'red',
    icon: 'RiDashboard3Line',
    categories: [t('widgets.compliancesCounter.category')],
    previewWidth: '45%',

    initialState: {
      size: { width: 25, height: 400 },
      data: {}
    },

    Presentation: Widget,
    Form: EditWidgetForm
  }
}
